import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { priceOffer } from '../../utils/priceOffer';

export default function PriceOfferBar({ config }) {
    const offer = priceOffer(config);
    if (!offer) return null;
    const detail = offer.lines.filter((line) => (
        line !== `Wash & Fold from ${offer.priceText}`
        && line !== `Drop-off wash & fold ${offer.priceText}`
        && line !== 'Easy online scheduling'
    ));

    return (
        <Box bg="gray.900" color="white" py={{ base: 5, md: 7 }} px={4} textAlign="center" data-testid="home-price-offer">
            <VStack spacing={2} maxW="4xl" mx="auto">
                <Text fontSize={{ base: '2xl', md: '4xl' }} fontWeight="800" lineHeight="1.05">
                    {offer.headlineLead}{offer.priceText}
                </Text>
                <Text fontSize={{ base: 'sm', md: 'lg' }} color="gray.100">
                    {detail.join(' · ')}
                </Text>
                <Text as="a" href={`/${config?.laundryId || '1'}`} fontWeight="700" color="orange.200" textDecoration="underline">
                    Schedule online
                </Text>
            </VStack>
        </Box>
    );
}
